import React, { createContext, useEffect, useState } from 'react'

import Cookies from 'js-cookie'
import { useSessionService } from 'hooks/useSessionService'
import { useErrorService } from 'hooks/useErrorService'
import { io } from 'socket.io-client'

export const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
  const [isLogged, setIsLogged] = useState(false)
  const sessionService = useSessionService()
  const errorService = useErrorService()
  const [currentUser, setCurrentUser] = useState()
  const [permissoesUsuario, setPermissoesUsuario] = useState([])
  const [socket, setSocket] = useState(null)

  const signOut = () => {
    Cookies.remove('auth-sigep')
    Cookies.remove('auth-tempo')
    if (socket) {
      socket.disconnect()
      setSocket(null)
    }
    setIsLogged(false)
    setPermissoesUsuario([])
  }

  useEffect(() => {
    if (socket && currentUser) {
      socket.emit('novoUsuario', currentUser.id)
    }
  }, [socket, currentUser])

  useEffect(() => {
    if (currentUser?.permNegs?.some((permissaoNegada) => permissaoNegada.target === 'AUTENTICAR_USUARIO_LOCAL')) {
      signOut()
    }
  }, [currentUser])

  const getProfile = async () => {
    try {
      const data = await sessionService.renewToken()

      if (!data || !data.data) signOut()
      if (!socket) {
        setSocket(io(`${process.env.REACT_APP_API_DNS}`))
      }

      Cookies.set('auth-sigep', data.data.token)
      Cookies.set('auth-tempo', new Date())
      setCurrentUser(data.data.usuario)
      setIsLogged(true)
      const permissoes = []
      data.data.usuario.cargo.perms.map((perm) => permissoes.push(perm.target))
      data.data.usuario.permAdics.map((perm) => permissoes.push(perm.target))
      data.data.usuario.permNegs.forEach((perm) => {
        permissoes.forEach((permissaoAdicionada, index) => {
          if (permissaoAdicionada === perm.target) {
            permissoes.splice(index, 1)
          }
        })
      })
      setPermissoesUsuario(permissoes)
    } catch (error) {
      signOut()
    }
  }

  const logIn = async ({ cpf, senha }, router) => {
    try {
      Cookies.remove('auth-sigep')
      Cookies.remove('auth-tempo')
      setIsLogged(false)
      setPermissoesUsuario([])
      const data = await sessionService.login({
        cpf,
        senha,
      })

      if (data.data) {
        if (data.data.token === 'invalido') {
          setCurrentUser(data.data.usuario)
          router.history.push('/auth/usuariopendente')
          return
        }

        const permissoes = []
        data.data.usuario.cargo.perms.map((perm) => permissoes.push(perm.target))
        data.data.usuario.permAdics.map((perm) => permissoes.push(perm.target))
        setPermissoesUsuario(permissoes)
        setIsLogged(true)
        setCurrentUser(data.data.usuario)
        Cookies.set('auth-sigep', data.data.token)

        router.history.push(`/`)
      } else {
        const err = {
          response: {
            status: 500,
            data: {
              error: {
                innerError: {
                  message: 'Erro ao processar a solicitação', // erro genérico para quando não há dados na resposta da rota 
                },
              },
            },
            case: 'login',
          },
        }
        signOut()
        throw err
      }
    } catch (err) {
      if(err?.response?.status == 401) {
        const error = {
          response: {
            status: 401,
            data: {
              error: {
                innerError: {
                  message: 'Credenciais inválidas',
                },
              },
            },
            case: 'login',
          },
        }
        signOut()
        errorService.tratarErro(error)
      }
      else {
        errorService.tratarErro(err)
      }
    }
  }

  const verificarPermissao = (permissoes) => {
    if (!permissoes.length) return false
    if (permissoes.some((permissao) => permissoesUsuario.includes(permissao))) return true
  }

  const verificarSetor = (idsSetores) => {
    if (!idsSetores.length || !currentUser.setores) return false
    let result = false
    idsSetores.forEach((idSetor) => {
      currentUser.setores.forEach((setorUsuario) => {
        if (idSetor === setorUsuario.id) {
          result = true
        }
      })
    })
    return result
  }

  return (
    <AuthContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        logIn,
        isLogged,
        currentUser,
        permissoesUsuario,
        signOut,
        getProfile,
        verificarPermissao,
        verificarSetor,
        socket,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
